var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mask",on:{"click":_vm.close}}),_c('div',{staticClass:"pop"},[_vm._t("pop")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }